import { sdk } from '@/lib/api';
import { FetchError } from '@/lib/api/client';
import { queryKeysFactory } from '@/lib/query-key-factory';
import { HttpTypes } from '@/types';
import { IProduct } from '@/types/product';
import {
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import Cookies from 'js-cookie';

const PRODUCT_DETAIL_QUERY_KEY = 'product-detail' as const;

export const productDetailQueryKeys = queryKeysFactory(PRODUCT_DETAIL_QUERY_KEY);

export const useProductDetail = (
  slug?: string,
  token?: string,
  options?: Omit<
    UseQueryOptions<
      HttpTypes.IResponse<IProduct>,
      FetchError,
      HttpTypes.IResponse<IProduct>,
      QueryKey
    >,
    'queryFn' | 'queryKey'
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: productDetailQueryKeys.detail(slug as string),
    queryFn: async () => sdk.site.homepage.retrieveProductDetail(slug as string, token as string),
    enabled: !!slug && options?.enabled,
    ...options,
  });

  return { ...data, ...rest };
};

export const useGetProductDetail = (
  token?: string,
  options?: UseMutationOptions<HttpTypes.IResponse<IProduct>, FetchError, string>
) => {
  return useMutation({
    mutationFn: (payload) => {
      const locationId = Cookies.get('_location_id');
      return sdk.site.homepage.retrieveProductDetail(
        payload as string,
        token as string,
        locationId
      );
    },
    onSuccess(data, variables, context) {
      options?.onSuccess?.(data, variables, context);
    },
    ...options,
  });
};
